import { csrfToken, url2link } from '@/js/_common';
import { setEvent as setFavoriteEvent } from '@/js/_components/parts/favorite';
import Mustache from 'mustache';
import entryConfirmHtml from '@/js/html_templates/entry-confirm-modal.html';
import entryErrorHtml from '@/js/html_templates/entry-error-modal.html';
import Modal from '@/js/plugins/modal';

const main = () => {
    if (document.querySelector('#page-user-job-show') == null) return;

    // URLをリンクタグに置き換え
    url2link('.p-block__content');

    // お気に入りボタン
    document.querySelectorAll('.p-footer__button[data-type="favorite"]').forEach((el) => {
        setFavoriteEvent(el);
    });

    if (document.querySelector('.p-footer__button[data-type="entry"]')) {
        document.querySelector('.p-footer__button[data-type="entry"]').addEventListener('click', async (e) => {
            const modal = new Modal();
            let html = '';
            e.preventDefault();

            if (e.target.dataset.chkProfile == '1') {
                html = Mustache.render(entryConfirmHtml, {
                    button_url: e.target.dataset.applyUrl,
                    token: csrfToken,
                });
            } else {
                html = Mustache.render(entryErrorHtml, {
                    button_url: e.target.dataset.applyUrl,
                    job_id: e.target.dataset.jobId,
                });
            }
            modal.setHtml(html);
            modal.show();

            document.querySelector('.p-entry-confirm-modal .c-buttons-default[data-action="cancel"]').addEventListener('click', () => {
                modal.close();
            });
        });
    }
}

export default main;
